@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load your sessions" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (VM) {
<section class="oep-nom" [attr.aria-busy]="Busy">
  <!-- markup.html:663-664 -->
  <h1 class="oep-nom__h1">Nominate a presenter for an award</h1>
  <p class="oep-nom__intro">{{ VM.Intro }}</p>

  <!-- markup.html:666-670 -->
  <div class="oep-nom__callout">
    <h2 class="oep-nom__callout-title">Nominate only the very best</h2>
    <p class="oep-nom__callout-text">Do not nominate every OEP presenter in your session; only nominate the very best. If none are outstanding, you do not need to submit a nomination. Presenters will not see your nomination form.</p>
    <div class="oep-nom__deadline">{{ VM.DeadlineLine }}</div>
  </div>

  <!-- markup.html:671-682 -->
  @if (VM.Tiles.length) {
    <ul class="oep-nom__tiles">
      @for (t of VM.Tiles; track $index) {
        <li><a class="oep-nom__tile" [href]="t.Url" target="_blank" rel="noopener">
          <span class="oep-nom__tile-kind">{{ t.Kind }}</span>
          <span class="oep-nom__tile-title">{{ t.Title }}</span>
          <span class="oep-nom__tile-note">{{ t.Note }}</span>
        <span class="oep-sr"> (opens in a new tab)</span></a></li>
      }
    </ul>
  }
  <!-- markup.html:683 -->
  <p class="oep-nom__visibility">You see the presentations in your own sessions, including the final presentation each presenter uploaded. Draft files and reviewer feedback stay between presenters and their reviewers.</p>

  <!-- markup.html:685-706 -->
  @if (VM.Sessions.length === 0) {
    <mj-empty-state Variant="empty" Title="No sessions yet" Message="If you expected one, reply to your OEP email or write to membership@agu.org." />
  }
  <ul class="oep-nom__sessions">
    @for (s of VM.Sessions; track s.SessionID) {
      <li class="oep-nom__session" [attr.aria-labelledby]="'oep-sess-' + s.SessionID">
        <div class="oep-nom__session-head">
          <span class="oep-nom__code">{{ s.Code }}</span>
          <h2 class="oep-nom__session-title" [id]="'oep-sess-' + s.SessionID">{{ s.Title }}</h2>
          <span class="oep-nom__session-meta">{{ s.Meta }}</span>
        </div>
        <ul class="oep-nom__presenters">
          @for (p of s.Presenters; track p.PresentationID) {
            <li class="oep-nom__presenter">
              <div class="oep-nom__body">
                <h3 class="oep-nom__title">{{ p.Title }}</h3>
                <div class="oep-nom__meta">{{ p.Meta }}</div>
                <div class="oep-nom__final">{{ p.FinalNote }}@if (p.FinalFileID) { <button type="button" class="oep-nom__link" (click)="ViewFinal(p)">View final presentation</button> }</div>
              </div>
              <button type="button" class="oep-nom__cta" [attr.data-state]="p.Nominated ? 'done' : (p.CtaEnabled ? 'open' : 'locked')"
                [disabled]="!p.CtaEnabled" (click)="Open(p)">{{ p.Cta }}</button>
            </li>
          }
        </ul>
      </li>
    }
  </ul>
  <p class="oep-nom__status" role="status" aria-live="polite" [attr.data-tone]="Status?.Tone">{{ Status?.Text }}@if (Status?.Link; as l) { <a [href]="l.Url" target="_blank" rel="noopener">{{ l.Label }}<span class="oep-sr"> (opens in a new tab)</span></a> }</p>
</section>
}
